module.exports = __webpack_public_path__ + "flowers.359258e9.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/content/flowers.png
 ** module id = 108
 ** module chunks = 0
 **/